import React, { useState, useCallback, useEffect } from "react";
import { isVerified, getCountryByCode } from "../../../../../../utils/Helper";
import { BackNextButton, AddButton, Modal, EditCard, Button, } from "../../../../../common";
import { EditCardItems } from "../EditCardItems";
import { Search } from "./Search";
import { AddRelatedForm } from "./AddRelatedForm";
import { ReactComponent as Pen } from "../../../../../../assets/images/companyIcons/pen.svg";
import { AddCompanyName } from "./AddCompanyName";
import { useGetCompanyQuery, useCreateBusinessRelationMutation, useCreateBusinessRelationDraftMutation, useUpdateBusinessRelationMutation, useUpdateBusinessRelationDraftMutation, useCreateCompanyMutation, useBusinessRelationDraftFetchMutation, useGetCompanyDetailsMutation, useDeleteBusinessRelationDraftMutation } from "../../../../../../store/Company/companyApiSlice";
import { useSelector, useDispatch } from "react-redux";
import useSearchCompany from "../../../../../../Hooks/useSearchCompany";
import { setCurrentEditingCompany } from "../../../../../../store/Company/companySlice";
import { ReactComponent as MapmarkerIcon } from "../../../../../../assets/images/companyIcons/CompanyProfile/mapMarker.svg";
import { ReactComponent as TypeIcon } from "../../../../../../assets/images/companyIcons/CompanyProfile/type2.svg";
import { ReactComponent as NameIcon } from "../../../../../../assets/images/companyIcons/CompanyProfile/name.svg";
import { ReactComponent as StateIcon } from "../../../../../../assets/images/companyIcons/CompanyProfile/stateIcon.svg";
import { ReactComponent as Delete } from "../../../../../../assets/images/companyIcons/delete1.svg"
import { ReactComponent as Verified } from "../../../../../../assets/icons/verified.svg";
import { ReactComponent as Declined } from "../../../../../../assets/icons/cancel.svg";
import { ReactComponent as Requested } from "../../../../../../assets/icons/pending.svg";
import { ReactComponent as Skipped } from "../../../../../../assets/icons/review.svg";

import useCompanyUpdate from "../useCompanyFollowUpdate"
import { toSentenceCase } from "../../../../../../global_functions/global";
export const BusinessRelation = ({ onPrev, onNext, onSkip, verifyStatus, handleUpdateStatus, compRefetch }) => {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [showAddCompany, setShowAddCompany] = useState(false);
  const [showForm, setShowForm] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState();
  const [getCompanyDetails] = useGetCompanyDetailsMutation();
  const [selectedCompanyName, setSelectedCompanyName] = useState("");
  const [relation, setBusinessRelation] = useState([]);
  const [relationDraft, setBusinessRelationDraft] = useState([]);
  const [editBusiness, setEditBusiness] = useState(null);
  const [editType, setEditType] = useState("");
  const [countryCodeSearch, setCountryCodeSearch] = useState("");
  const { currentEditingCompany } = useSelector((state) => state.company);
  const { token } = useSelector((state) => state.auth);
  const [BusinessRelationDraft] = useBusinessRelationDraftFetchMutation();
  const [createBusinessRelation, { isLoading: creating }] = useCreateBusinessRelationMutation();
  const [createBusinessRelationDraft, { isLoading: isCreatingDraft }] = useCreateBusinessRelationDraftMutation();
  const [updateBusinessRelation, { isLoading: isCreating }] = useUpdateBusinessRelationMutation();
  const [updateBusinessRelationDraft, { isLoading: isDraftUpdating }] = useUpdateBusinessRelationDraftMutation();
  const { data: updatedCompanyData, refetch } = useGetCompanyQuery({ companyId: currentEditingCompany?.companyID, token, });
  const handleUpdateCompany = useCompanyUpdate();
  const [deleteDraft] = useDeleteBusinessRelationDraftMutation()
  const [dataChanged, setDataChanged] = useState(false);

  useEffect(() => {
    if (updatedCompanyData) {
      dispatch(setCurrentEditingCompany(updatedCompanyData));
    }
  }, [updatedCompanyData, dispatch, isOpen, dataChanged]);

  useEffect(() => {
    if (!currentEditingCompany) return;
    let resultArr = [];
    let Dettemp = currentEditingCompany?.businessRelation?.forEach(function (obj) {
      if (obj?.business_relationID?.is_deleted == 0) {
        resultArr.push(obj)
      }
    });
    setBusinessRelation(resultArr);

    const companyStatus = async () => {
      let dataval = await BusinessRelationDraft({
        companyID: currentEditingCompany?.companyID,
        token,
      });
      if (dataval?.data?.data) {
        let respData = dataval?.data?.data;
        let tempArr = [];
        let draft_ids = [];
        let ids = [];
        let main_ids = [];
        for (let i = 0; i < respData.length; i++) {
          draft_ids.push(respData[i]?.business_relationID_id);
          tempArr.push(respData[i]);
        }
        currentEditingCompany?.businessRelation?.forEach(function (obj) {
          if (obj?.business_relationID?.is_deleted == 0) {
            ids.push(obj?.business_relationID?.business_relationID)
          }
        });
        ids.forEach(function (id) {
          if (!draft_ids.includes(id))
            main_ids.push(id)
        })
        currentEditingCompany?.businessRelation?.forEach(function (obj) {
          if (obj?.business_relationID?.is_deleted == 0) {
            if (main_ids.includes(obj?.business_relationID?.business_relationID)) {
              tempArr.push(obj?.business_relationID)
            }
          }
        });
        setBusinessRelationDraft(tempArr)
      }
    }
    companyStatus();
  }, [currentEditingCompany, dataChanged, updatedCompanyData]);
  const [createCompany] = useCreateCompanyMutation();
  function searchCompany(fn, wait) {
    let timeout;
    return function (...args) {
      const context = this;
      if (timeout) clearTimeout(timeout);
      timeout = setTimeout(() => {
        timeout = null;
        fn.apply(context, args);
      }, wait);
    };
  }
  const searchOnChange = useCallback(searchCompany(setSearchQuery, 400), []);
  const { worldBoxToken } = useSelector((state) => state.search);
  const { data, isLoading, error, message } = useSearchCompany(
    searchQuery,
    countryCodeSearch,
    token,
    worldBoxToken
  );
  useEffect(() => {
    if (data) {
      setSearchResults(data);
    }
  }, [data, dataChanged, updatedCompanyData]);
  const modalHandle = (business_relationID, type) => {
    setEditType(type);
    setIsOpen(!isOpen);
    setSearchResults([]);
    if (type === "edit") {
      setSelectedCompany({ name: business_relationID?.companyID?.registered_company_name || business_relationID?.registered_company_name });
    }
    else {
      setSelectedCompany(null)
    }
    setSearchQuery("");
    setEditBusiness(business_relationID);
    setSelectedCompanyName(business_relationID?.companyID?.registered_company_name || business_relationID?.registered_company_name);
  };
  const handleAddNewCompany = () => {
    setShowAddCompany((prev) => !prev);
    setShowSearch((prev) => !prev);
    setSearchResults([]);
    setSelectedCompany(null);
    setSearchQuery("");
  };
  const handleSearchShow = () => {
    setShowSearch((prev) => !prev);
    setShowForm((prev) => !prev);
  };
  const handleFormShow = (companyData) => {
    if (selectedCompany || companyData) {
      setShowSearch(false);
      setShowForm(true);
      setShowAddCompany(false);
    }
  };
  const handleSearch = ({ searchTerm, countryCode }) => {
    if (searchTerm.length < 3) {
      setSearchResults([]);
    }
    if (searchTerm.length >= 3) {
      setCountryCodeSearch(countryCode);
      searchOnChange(searchTerm);
    }
  };
  const getSelectedCompany = (company) => {
    setSelectedCompany(company);
  };
  const verifiedData = currentEditingCompany.verifiedCompany;
  const handleRelatedSubmit = async (companyData) => {
    if (isVerified(verifiedData)) {
      if (editType === 'edit') {
        try {
          const businessRelationId = editBusiness?.business_relationID;
          const CompanyId = editBusiness?.companyID?.companyID;
          const CurrentcompanyID = currentEditingCompany.companyID;
          if (editBusiness?.business_relation_DraftID) {
            if (editBusiness?.business_relationID_id != undefined && editBusiness?.business_relationID_id != null) {
              const res = await updateBusinessRelationDraft({
                data: {
                  current_companyID: CurrentcompanyID,
                  relation_type: companyData.relation_type,
                  country: companyData?.country,
                  state: companyData?.state,
                  companyID: CompanyId,
                  business_relationID: businessRelationId || editBusiness?.business_relationID_id,
                },
                business_relationId: editBusiness?.business_relation_DraftID,
                token,
              }).unwrap();
              if (res) {
                compRefetch();
                refetch()
                setDataChanged(!dataChanged);
                modalHandle();
              }
            } else {
              const res = await updateBusinessRelationDraft({
                data: {
                  current_companyID: CurrentcompanyID,
                  relation_type: companyData.relation_type,
                  country: companyData?.country,
                  state: companyData?.state,
                  companyID: CompanyId,
                },
                business_relationId: editBusiness?.business_relation_DraftID,
                token,
              }).unwrap();

              if (res) {
                compRefetch();
                refetch()
                setDataChanged(!dataChanged);
                modalHandle();
              }
            }
          } else {
            const res = await createBusinessRelationDraft({
              data: {
                current_companyID: currentEditingCompany.companyID,
                relation_type: companyData.relation_type,
                country: companyData?.country,
                state: companyData?.state,
                companyID: data?.companyID,
                registered_company_name: companyData.name,
                business_relationID: businessRelationId || companyData?.business_relationID,
              },
              token,
            }).unwrap();
            if (res) {
              compRefetch();
              refetch()
              setDataChanged(!dataChanged);
              modalHandle();
            }

          }

        } catch (error) {
        } finally {
          compRefetch();
          refetch()
          setDataChanged(!dataChanged);
          modalHandle();
        }
      }
      else {
        try {
          if (companyData?.trevex_id) {
            const res = await createBusinessRelationDraft({
              data: {
                current_companyID: currentEditingCompany.companyID,
                relation_type: companyData.relation_type,
                country: companyData?.country,
                state: companyData?.state,
                companyID: companyData?.trevex_id,
                registered_company_name: companyData.name,
                business_relationID: companyData?.business_relationID,
              },
              token,
            }).unwrap();
            if (res) {
              compRefetch();
              refetch()
              setDataChanged(!dataChanged);
              modalHandle();
            }
          } else {
            let data = {};
            if (companyData?.win || companyData?.wb_win) {
              const { data: createdCompany } = await createCompany({
                data: {
                  wb_win: (companyData.win || companyData?.wb_win),
                  registered_company_name: companyData.name,
                  country_code: companyData.country,
                },
                token,
              }).unwrap();

              data = createdCompany;
            }

            const res = await createBusinessRelationDraft({
              data: {
                current_companyID: currentEditingCompany.companyID,
                relation_type: companyData.relation_type,
                country: companyData?.country,
                state: companyData?.state,
                companyID: data?.companyID,
                registered_company_name: companyData.name,
                business_relationID: companyData?.business_relationID,
              },
              token,
            }).unwrap();
            if (res) {
              compRefetch();
              refetch()
              setDataChanged(!dataChanged);
              modalHandle();

            }
          }
        } catch (error) {
        }
      }

    }
    else {
      if (editType === 'edit') {
        try {
          const businessRelationId = editBusiness?.business_relationID;
          const currentCompanyId = editBusiness?.companyID?.companyID;
          const res = await updateBusinessRelation({
            token,
            business_relationId: businessRelationId,
            related_entityId: currentEditingCompany?.related_entityID,
            data: {
              current_companyID: currentCompanyId,
              company_name: editBusiness?.companyID?.registered_company_name,
              relation_type: companyData?.relation_type,
              state: companyData?.state,
              country: companyData?.country,
              registered_company_name: companyData.name,
            },
          });
          if (res) {
            const result = await handleUpdateCompany(currentEditingCompany.companyID, "Business Relation Updated", token);
            if (!result.success) {
              console.error(result.error);
              if (result) {
                compRefetch();
                refetch()
                setDataChanged(!dataChanged);
              }
            }
            compRefetch();
            refetch()
            setDataChanged(!dataChanged);
          }
        } catch (error) {
        } finally {
          modalHandle();
        }
      } else {
        try {
          if (companyData?.trevex_id) {
            const res = await createBusinessRelation({
              data: {
                current_companyID: currentEditingCompany.companyID,
                relation_type: companyData.relation_type,
                country: companyData?.country,
                state: companyData?.state,
                companyID: companyData?.trevex_id,
              },
              token,
            }).unwrap();
            if (res) {
              const result = await handleUpdateCompany(currentEditingCompany.companyID, "New Business Relation Added", token);
              if (!result.success) {
                console.error(result.error);
              }
              if (result) {
                compRefetch();
                refetch()
                setDataChanged(!dataChanged);
              }
              modalHandle();
            }
          } else {
            let data = {};
            if (companyData.win) {
              const { data: companyData } = await createCompany({
                data: {
                  wb_win: companyData.win,
                  registered_company_name: companyData.name,
                  country_code: companyData.country,
                },
                token,
              }).unwrap();
              data = companyData;
            }
            if (data) {
              const res = await createBusinessRelation({
                data: {
                  current_companyID: currentEditingCompany.companyID,
                  relation_type: companyData.relation_type,
                  country: companyData?.country,
                  state: companyData?.state,
                  companyID: data?.companyID,
                  registered_company_name: (data?.registered_company_name || companyData.name),
                },
                token,
              }).unwrap();
              if (res) {
                compRefetch();
                refetch()
                setDataChanged(!dataChanged);
                modalHandle();
                const result = await handleUpdateCompany(currentEditingCompany.companyID, "New Business Relation Added", token);
                if (!result.success) {
                  console.error(result.error);
                }
                if (result) {
                  compRefetch();
                  refetch()
                  setDataChanged(!dataChanged);
                  modalHandle();
                }
              }
            }
          }

        } catch (error) {
        }
      }
    }
  };

  function createArrayFromObject(object) {
    let otherData = ["registered_company_name", "country", "state", "relation_type"];
    let icons = {
      country: <MapmarkerIcon />,
      state: <StateIcon />,
      registered_company_name: <NameIcon />,
      relation_type: <TypeIcon />,
    };
    let data = [];
    let companyName;

    if (object?.companyID?.registered_company_name) {
      companyName = object?.companyID?.registered_company_name;
    } else if (object?.registered_company_name) {
      companyName = object?.registered_company_name;
    } else if (object?.companyName) {
      companyName = object?.companyName
    }

    const newObject = {
      "business_relationID": object.business_relationID,
      "registered_company_name": companyName,
      "relation_type": toSentenceCase((object?.relation_type || '').replace(/_/g, " ")),
      "state": object.state,
      "country": getCountryByCode(object.country),
    }

    for (let key in newObject) {
      if (otherData.includes(key)) {
        data.push({ [key]: newObject[key], icon: icons[key] });
      }
    }

    let keyValuePairs = data.map((item) =>
      Object.entries(item).map(([key, value]) => [key, value])
    );

    let html = keyValuePairs.map((item) => (
      <EditCardItems
        heading={item[0][0]?.replaceAll("_", " ")}
        subHeading={item[0][1]?.replace("|", "")}
        icon={item[1][1]}
      />
    ));
    return html;
  }
  const modalHandleDelete = async (deleteInfo) => {
    if (deleteInfo?.business_relation_DraftID) {
      let dataval = await deleteDraft({
        data: deleteInfo?.business_relation_DraftID,
      });
      if (dataval?.data == null) {
        alert("Business Relation Deleted Successfully");
        compRefetch();
        refetch()
        setDataChanged(!dataChanged);
        // window.location.reload()
      }
    } else if (deleteInfo?.business_relationID) {
      const formData = new FormData();
      formData.append("is_deleted", 1);
      let res = await updateBusinessRelation({
        data: formData,
        business_relationId: deleteInfo?.business_relationID,
        token,
      }).unwrap();
      if (res?.is_deleted == 1) {
        handleUpdateStatus()
        alert("Bussiness Relation Deleted Successfully");
        compRefetch();
        refetch()
        setDataChanged(!dataChanged);
      }
    }
  }
  return (
    <div className="mt-5 mr-20">
      {isOpen && (
        <Modal modalHandle={modalHandle}>
          {showForm && (
            <>
              <div className="test1">
                <AddRelatedForm
                  title={editType == 'edit' ? "Edit Business Relation" : "Add Business Relation"}
                  onSearch={handleSearchShow}
                  selectedCompany={selectedCompany}
                  selectedCompanyName={selectedCompanyName}
                  showForm={handleFormShow}
                  handleRelatedSubmit={handleRelatedSubmit}
                  isLoading={creating || isCreating || isCreatingDraft || isDraftUpdating}
                  editRelatedEntities={editBusiness}
                  type={editType}
                  from='businessRelation'
                />
              </div>
            </>
          )}
          {showSearch && (
            <>
              <div className="test2">
                <Search
                  onSearch={handleSearch}
                  results={searchResults}
                  isLoading={isLoading}
                  getSelectedCompany={getSelectedCompany}
                  showForm={handleFormShow}
                  handleSearchShow={handleSearchShow}
                  handleAddNewCompany={handleAddNewCompany}
                  breadPrev="Add Business Relation"
                  breadNext="Select Company"
                  searchLabel="Search your Company"
                  searchEmptyText="Search & Select your company"
                  error={error}
                  message={message}
                />
              </div>
            </>
          )}
          {showAddCompany && (
            <>
              <div className="test3">
                <AddCompanyName
                  handleAddNewCompany={handleAddNewCompany}
                  handleCompanySubmit={handleFormShow}
                  breadNext={"Add Company Name"}
                  breadPrev={"Select company"}
                  label={"Add Company Name"}
                  handleSelectedCompany={getSelectedCompany}
                  isLoading={creating || isCreating || isCreatingDraft}
                />
              </div>

            </>
          )}
        </Modal>
      )}
      <h3 className="text-f20 font-semibold text-secondarytwo text-left mb-2">
        Add Business Relation
      </h3>

      <div className="border border-slate rounded-lg p-8 mb-6">
        <AddButton
          text="Add Business Relation"
          buttonText="Add Business Relation"
          onClick={() => modalHandle(null)}
        />
        <div className="grid grid-cols-2 gap-4">
          {relationDraft.length <= 0 && relation?.map((item) => (
            <EditCard>
              <div className="statusSection">
                {item.business_relationID.status === "Verified" && (
                  <Verified />
                )}
                {item.business_relationID.status === "Declined" && (
                  <Declined />
                )}
                {item.business_relationID.status === "Skipped" && (
                  <Skipped />
                )}
                {(item?.business_relationID?.status === "Requested" || item?.business_relationID?.status === "raised" || item?.business_relationID?.status === "pending") && (
                  <Requested />
                )}
              </div>
              <div className="h-[17rem] overflow-y-auto relative  my-2">
                {createArrayFromObject({
                  ...item?.companyID,
                  ...item?.business_relationID,
                })}
              </div>
              <div className="actionseditDelete  gap-4">
                <Button onClick={() => modalHandle(item?.business_relationID, 'edit')}
                  classes="bg-white/[.2] w-full border border-white/[0.3] rounded flex items-center justify-center gap-2 p-2 text-white relative">
                  <span>Edit Details</span>
                  <span>
                    <Pen />
                  </span>
                </Button>
                <Button
                  onClick={() => modalHandleDelete(item?.business_relationID)}
                  classes="bg-white/[.2] w-full border border-white/[0.3] rounded flex items-center justify-center gap-2 p-2 text-white relative"
                >
                  <span>Delete</span>
                  <span>
                    <Delete />
                  </span>
                </Button>
              </div>
            </EditCard>
          ))}
          {relationDraft?.map((item) => (
            <EditCard>
              <div className="statusSection">
                {item.status === "Verified" && (
                  <Verified />
                )}
                {item.status === "Declined" && (
                  <Declined />
                )}
                {item.status === "Skipped" && (
                  <Skipped />
                )}
                {(item?.status === "Requested" || item?.status === "raised" || item?.status === "pending") && (
                  <Requested />
                )}
              </div>
              <div className="h-[17rem] overflow-y-auto relative  my-2">
                {createArrayFromObject({ ...item })}
              </div>
              <div className="actionseditDelete  gap-4">
                <Button onClick={() => modalHandle(item, 'edit')}
                  classes="bg-white/[.2] w-full border border-white/[0.3] rounded flex items-center justify-center gap-2 p-2 text-white relative">
                  <span>Edit Details</span>
                  <span>
                    <Pen />
                  </span>
                </Button>
                <Button
                  onClick={() => modalHandleDelete(item)}
                  classes="bg-white/[.2] w-full border border-white/[0.3] rounded flex items-center justify-center gap-2 p-2 text-white relative"
                >
                  <span>Delete</span>
                  <span>
                    <Delete />
                  </span>
                </Button>
              </div>
            </EditCard>
          ))}
        </div>
      </div>
      <BackNextButton
        onPrev={() => onPrev(6, "Business Relation", "Details")}
        onNext={() => onNext(0, "Banking Information", "Financial")}
        onSkip={() => onSkip(0, "Banking Information", "Financial")}
      />
    </div>
  );
};
